import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Home24Regular,
  People24Regular,
  Folder24Regular,
  Money24Regular,
  DocumentText24Regular,
  Table24Regular,
  Settings24Regular,
  Library24Regular,
  Toolbox24Regular,
  Box24Regular,
} from "@fluentui/react-icons";

const navItemBase =
  "group relative flex h-9 items-center gap-3 rounded-sm px-3 text-[13px] transition-colors duration-150";

const navItemInactive =
  "text-[#323130] hover:bg-[#f3f2f1] hover:text-[#201f1e]";

const navItemActive =
  "bg-[#eaf3ff] font-semibold text-[#0f6cbd] before:absolute before:left-0 before:top-1 before:h-7 before:w-1 before:rounded-r before:bg-[#0f6cbd]";

function SidebarLink({ to, icon: Icon, label, end = false }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `${navItemBase} ${isActive ? navItemActive : navItemInactive}`
      }
    >
      <Icon className="h-5 w-5 shrink-0" />
      <span className="truncate">{label}</span>
    </NavLink>
  );
}

function SectionLabel({ children }) {
  return (
    <div className="px-3 pt-4 pb-1 text-[11px] font-semibold uppercase tracking-wide text-[#605e5c]">
      {children}
    </div>
  );
}

export default function Sidebar() {
  const location = useLocation();
  const [librariesOpen, setLibrariesOpen] = useState(true);

  const librariesActive = location.pathname.startsWith("/libraries");

  return (
    <aside className="flex h-screen w-60 shrink-0 flex-col border-r border-[#edebe9] bg-white">
      <div className="flex h-14 items-center border-b border-[#edebe9] px-4">
        <div className="flex h-8 w-8 items-center justify-center rounded-sm bg-[#0f6cbd] text-sm font-bold text-white shadow-sm">
          Ø
        </div>

        <div className="ml-3 min-w-0 leading-tight">
          <div className="truncate text-sm font-semibold text-[#201f1e]">
            Øresund Byg
          </div>
          <div className="truncate text-xs text-[#605e5c]">
            Dynamics workspace
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-2 py-3">
        <SectionLabel>Workspace</SectionLabel>

        <div className="space-y-1">
          <SidebarLink to="/" end icon={Home24Regular} label="Overblik" />
          <SidebarLink to="/customers" icon={People24Regular} label="Kunder" />
          <SidebarLink to="/projects" icon={Folder24Regular} label="Projekter" />
          <SidebarLink to="/economy" icon={Money24Regular} label="Økonomi" />
        </div>

        <SectionLabel>Sales</SectionLabel>

        <div className="space-y-1">
          <SidebarLink to="/todo" icon={DocumentText24Regular} label="To-do" />
          <SidebarLink to="/quotes" icon={DocumentText24Regular} label="Nyt tilbud" />
          <SidebarLink to="/quotes-list" icon={Table24Regular} label="Tilbudsliste" />
        </div>

        <SectionLabel>Data</SectionLabel>

        <button
          type="button"
          onClick={() => setLibrariesOpen((prev) => !prev)}
          className={`${navItemBase} w-full justify-between ${
            librariesActive ? navItemActive : navItemInactive
          }`}
        >
          <span className="flex min-w-0 items-center gap-3">
            <Library24Regular className="h-5 w-5 shrink-0" />
            <span className="truncate">Libraries</span>
          </span>

          <span className="text-xs text-[#605e5c]">
            {librariesOpen ? "▾" : "▸"}
          </span>
        </button>

        {librariesOpen && (
          <div className="mt-1 space-y-1 pl-4">
            <SidebarLink
              to="/libraries/labour"
              icon={Toolbox24Regular}
              label="Labour Library"
            />
            <SidebarLink
              to="/libraries/materials"
              icon={Box24Regular}
              label="Material Library"
            />
          </div>
        )}
      </nav>

      <div className="border-t border-[#edebe9] px-2 py-3">
        <SidebarLink
          to="/settings"
          icon={Settings24Regular}
          label="Indstillinger"
        />
      </div>
    </aside>
  );
}